module.exports = __webpack_public_path__ + "static/img/gift-box-effect-blue.167a6dc.png";